// "typed name → SECOND NAME" when the office/product list name differs from what the partner wrote
const k = (s) => String(s || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
export const medName = (it) => {
  const sn = String(it.second_name || "").trim();
  return sn && k(sn) !== k(it.medicine) ? `${it.medicine} → ${sn}` : it.medicine;
};
